module.exports = __webpack_public_path__ + "img/index_banner.f6af441c.jpg";